import { createRouter, createWebHistory } from 'vue-router';

import HomePage from './components/HomePage.vue';
import IndexUser from './components/indexUser.vue';
import RegisterUser from './components/registerUser.vue';
import LoginUser from './components/loginUser.vue';
import ProfileUser from './components/profileUser.vue';
import GiftUser from './components/giftUser.vue';
import VerifyUser from './components/VerifyUser.vue';
import depositUser from './components/depositUser.vue';
import withdrawUSer from './components/withdrawUSer.vue';
import InternalUser from './components/InternalUser.vue';
import transactionUser from './components/transactionUser.vue';
import investmentUser from './components/investmentUser.vue';
import editUser from './components/editUser.vue';
import walletShow from './components/walletShow.vue';
import TicketUserComponent from './components/ticketUser.vue';
import seeTicket from './components/seeTicket.vue';
import BlockedUser from './components/BlockedUser.vue';
import myInvestments from './components/myInvestments.vue';
import LandingInfoPage from './components/LandingInfoPage.vue';
import store from './store'
import auth from './auth.middlware.js'
import verify from './verify.middleware.js'

// No need to import layout components here as they're handled separately
// in main.js and admin-main.js

// Split routes into main app routes and admin routes
const mainRoutes = [
  {
    path: '',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: 'contact',
    name: 'ContactPage',
    component: LandingInfoPage,
    meta: { publicPage: true }
  },
  {
    path: 'about-us',
    name: 'AboutPage',
    component: LandingInfoPage,
    meta: { publicPage: true }
  },
  {
    path: 'faq',
    name: 'FaqPage',
    component: LandingInfoPage,
    meta: { publicPage: true }
  },
  {
    path: 'dadehpardazan-way',
    name: 'JourneyPage',
    component: LandingInfoPage,
    meta: { publicPage: true }
  },
  {
    path: 'blocked',
    name: 'BlockedUser',
    component: BlockedUser,
    meta: {
      middleware: [auth] // only auth; verify will redirect others to this page
    }
  },
  {
    path: 'home',
    name: 'IndexUser',
    component: IndexUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'register',
    name: 'RegisterUser',
    component: RegisterUser,
  },
  {
    path: 'login',
    name: 'LoginUser',
    component: LoginUser,
  },
  {
    path: 'profile',
    name: 'ProfileUser',
    component: ProfileUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'gift',
    name: 'GiftUser',
    component: GiftUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'verify',
    name: 'VerifyUser',
    component: VerifyUser,
    meta: {
      middleware: [auth]
    }
  },
  {
    path: 'deposit',
    name: 'depositUser',
    component: depositUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'withdraw',
    name: 'withdrawUSer',
    component: withdrawUSer,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'internal',
    name: 'internalUser',
    component: InternalUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'transaction',
    name: 'transactionUser',
    component: transactionUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'investment',
    name: 'investmentUser',
    component: investmentUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'depositing',
    redirect: { name: 'contracts' }
  },
  {
    path: 'edit-user',
    name: 'editUser',
    component: editUser,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'wallet-user',
    name: 'walletShow',
    component: walletShow,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'ticket',
    name: 'ticketUser',
    component: TicketUserComponent,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'ticket/:id',
    name: 'seeTicket',
    component: seeTicket,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'my-investments',
    name: 'myInvestments',
    component: myInvestments,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'contracts',
    name: 'contracts',
    component: myInvestments,
    meta: {
      middleware: [auth, verify]
    }
  },
  {
    path: 'my-deposits',
    redirect: { name: 'contracts' }
  }
];

const routes = [
  {
    path: '/',
    children: mainRoutes
  },
  {
    path: '/:catchAll(.*)', // Catch-all route for 404
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
  const context = { to, from, next, store };

  const nextFactory = (ctx, mw, index) => {
    const subsequent = mw[index];
    if (!subsequent) return ctx.next;
    return (...params) => {
      if (params.length) {
        return ctx.next(...params);
      }
      const nextMiddleware = nextFactory(ctx, mw, index + 1);
      return subsequent({ ...ctx, next: nextMiddleware });
    };
  };

  const firstNext = nextFactory(context, middleware, 1);
  return middleware[0]({ ...context, next: firstNext });
});

export default router;